// When the grid offers an Undo button.
//
// Extracted from JobsPage so the rule can be tested. It is the browser's half
// of a decision the API also makes — undoRejection in app/api — and the server
// stays the authority. What this controls is whether the customer is OFFERED
// something that would then be refused, which is its own kind of bug: a button
// that exists and does not work reads as the product being broken.
//
// Three conditions, each for its own reason:
//
//   - A job that wrote nothing has nothing to revert.
//   - A job already 'undone' has been reverted. An UNDO job is itself
//     undoable, deliberately — that is how a mistaken undo gets walked back.
//   - ⚠ A job still RUNNING must not be offered. Its written count is still
//     climbing, so undoing it reverts the part that happened to have landed and
//     leaves the rest, producing a job that reads 'completed' with some of its
//     writes silently rolled back. It also puts two orchestrations on the
//     customer's instance at once, holding two of the licence's seats — which
//     is how an `API Login Limit` error arrives on their ERP from a button we
//     offered them.

/** Statuses that mean the work has finished, one way or another. */
const FINISHED = new Set(['completed', 'failed', 'undone']);

export interface UndoableJob {
  jobStatus: string;
  writtenCount: number;
}

export function canUndo(job: UndoableJob): boolean {
  if (!FINISHED.has(job.jobStatus)) return false;
  if (job.jobStatus === 'undone') return false;
  return job.writtenCount > 0;
}
